//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'
import { get } from 'lodash';
import { initialPermissions } from 'utils/config/reference';
import { useEffect, useState } from 'react';
import { useBookOrder } from 'store/books/selectors';


//  -- Examples data ------------------
const selecter = (state) => state.currentOrg;

//  -- Examples array selector --------
const orgTeacherSelecter = (state) => state.orgTeacherData;
export const useCurrentOrgPermission = () => {
    const selectedData = useSelector(selecter, shallowEqual)
    return get(selectedData,'permissions',initialPermissions) || initialPermissions;
}
export const useCurrentOrg = () => {
    const selectedData = useSelector(selecter, shallowEqual)
    return selectedData;
}

export const useOrgTimezone= () => {
    const selectedData = useCurrentOrg()
    return  get(selectedData,"parent.timezone") || get(selectedData,"timezone");
}
export const useParentOrgId = () => {
    const selectedData = useCurrentOrg()
    return get(selectedData, 'parent.id');
}
export const useParentOrg = () => {
    const selectedData = useCurrentOrg()
    return get(selectedData, 'parent');
}

export const useOrgStandardCodes = () => {
    const selectedData = useCurrentOrgPermission();
    const standardState = get(selectedData, 'standard_state', []);
    if (!Array.isArray(standardState)) return [];
  
    return standardState
      .filter(state => state.enabled === true)
      .map(state => state.code)
      .filter(Boolean);
}

const distDashboardSelecter = (state) => state.distDashboardInfo;
export const useDistrictDashboardInfo = () => {
    const selectedData = useSelector(distDashboardSelecter, shallowEqual)
    return selectedData;
}
const distExamGraphDataSelecter = (state) => state.distExamGraphData;
export const useExamGraphData = () => {
    const selectedData = useSelector(distExamGraphDataSelecter, shallowEqual)
    return selectedData;
}
const bookUsesGraphDataSelecter = (state) => state.distBookUsesData;
export const useBookUsesGraphData = () => {
    const selectedData = useSelector(bookUsesGraphDataSelecter, shallowEqual)
    return selectedData;
}
const distContentExamGraphDataSelecter = (state) => state.distContentExamData;
export const useContentExamGraphData = () => {
    const selectedData = useSelector(distContentExamGraphDataSelecter, shallowEqual)
    return selectedData;
}
const districtsSelector= state => state.districts;

export const useDistricts = () => {
    const selectedData = useSelector(districtsSelector, shallowEqual)
    return selectedData;
}
const vocab_permission_for_user_selector = state => state.vocab_permission_for_user;
export const useVoabPermissionForUser = () => {
    const selectedData = useSelector(vocab_permission_for_user_selector, shallowEqual)
    return selectedData;
}

const class_toggle_permission_selector = state => state.class_toggle_permission;
export const useClassTogglePermission = () => {
    const selectedData = useSelector(class_toggle_permission_selector, shallowEqual)
    return selectedData;
}

const adminHomeInfoSelecter = (state) => state.adminHomeInfo;
export const useAdminHomeInfo = () => {
    const selectedData = useSelector(adminHomeInfoSelecter, shallowEqual)
    return selectedData;
}
export const useBookPermissionForOrg = () => {
    const orgPermissions = useCurrentOrgPermission();
    const bookOrder = useBookOrder();
    const [book_permission, setBookPermission] = useState([]);
    useEffect(() => {
        const bookPermissions = get(orgPermissions, "books_group_permission", []);
        const permission = [];
        if (Array.isArray(bookOrder)) {
            bookOrder.forEach((book) => {
                const is_allowed = bookPermissions.some((permission) => permission === book.key);
                if (is_allowed) {
                    permission.push(...book.order)
                }
            });
        }
        setBookPermission(permission);
    }, [orgPermissions, bookOrder]);

    return book_permission;
}
